import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'encodeUriComponent'
})
export class EncodeUriComponentPipe implements PipeTransform {
  public transform(url: string): string {
    return encodeURIComponent(url);
  }
}
